/* Vivasio 16.10.2026 (Juroren 3:0, Go Inhaber): Kombinationen, die es nicht gibt, werden ausgeblendet statt
   durchgestrichen (wie Westwing, Manor, Connox, Urbanara). Durchgestrichen bleibt nur eine Variante, die es gibt,
   die aber ausverkauft ist; sie bleibt antippbar, damit «Benachrichtige mich» erscheint. Option 1 zeigt immer alle
   Werte; Option 2 nur Werte, die es zur Wahl in Option 1 gibt; Option 3 abhängig von 1 und 2. */
/* Vivasio 15.10.2026 (Inhaber, 2. Teil): Strich folgt der Auswahl. Eine Farbe ist durchgestrichen, wenn es sie
   in der gewählten Grösse nicht an Lager gibt; wechselt man auf eine Grösse, in der sie an Lager ist, verschwindet
   der Strich sofort. Gleiche Regel wie Impulse «Dynamische Varianten» (Option 1 nur durchgestrichen, wenn nirgends
   an Lager; Option 2 abhängig von Option 1; Option 3 von 1 und 2), aber ohne deren automatischen Farbwechsel:
   die gewählte Farbe bleibt, der Knopf zeigt «Ausverkauft». */
/* Vivasio 15.10.2026: Wer eine Farbe/Grösse antippt, die es in der aktuellen Kombination nicht gibt
   (z. B. Senfgelb nur in 140 x 200 cm, gewählt ist 90 x 130 cm), bekommt automatisch die passende
   bestehende Variante: der angetippte Wert bleibt, die andere Option springt auf eine vorhandene
   Kombination (zuerst an Lager). Vorher: «Nicht verfügbar», Farbname blieb stehen, kein
   «Benachrichtige mich». */
(function () {
  if (window.__vvVarianten) return;
  window.__vvVarianten = true;
  function wurzel(el) {
    var n = el;
    while (n && n !== document) {
      if (n.querySelector && n.querySelector('[data-variant-json]')) return n;
      n = n.parentNode;
    }
    return null;
  }
  function gewaehlt(root) {
    var werte = [];
    root.querySelectorAll('fieldset.variant-input-wrap').forEach(function (fs) {
      var i = parseInt((fs.getAttribute('data-index') || '').replace('option', ''), 10);
      var c = fs.querySelector('input[data-variant-input]:checked');
      if (i && c) werte[i - 1] = c.value;
    });
    return werte;
  }
  function strich(root) {
    var varianten;
    try { varianten = JSON.parse(root.querySelector('[data-variant-json]').value); } catch (err) { return; }
    var wahl = gewaehlt(root);
    root.querySelectorAll('fieldset.variant-input-wrap').forEach(function (fs) {
      var k = parseInt((fs.getAttribute('data-index') || '').replace('option', ''), 10) - 1;
      if (isNaN(k)) return;
      fs.querySelectorAll('.variant-input').forEach(function (div) {
        var inp = div.querySelector('input[data-variant-input]'), label = div.querySelector('label');
        if (!inp || !label) return;
        var passend = varianten.filter(function (v) {
          if (v.options[k] !== inp.value) return false;
          for (var j = 0; j < k; j++) { if (wahl[j] !== undefined && v.options[j] !== wahl[j]) return false; }
          return true;
        });
        var gibtEs = passend.length > 0;
        var kaufbar = passend.some(function (v) { return v.available; });
        div.hidden = !gibtEs;
        div.style.display = gibtEs ? '' : 'none';
        label.classList.toggle('disabled', gibtEs && !kaufbar);
        inp.classList.toggle('disabled', gibtEs && !kaufbar);
      });
    });
  }
  function alleStriche() {
    document.querySelectorAll('[data-variant-json]').forEach(function (el) { var r = wurzel(el); if (r) strich(r); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', alleStriche); else alleStriche();
  document.addEventListener('change', function (e) {
    var inp = e.target;
    if (!inp || !inp.matches || !inp.matches('input[data-variant-input]')) return;
    var root = wurzel(inp);
    if (root) setTimeout(function () { strich(root); }, 30);
  });
  document.addEventListener('change', function (e) {
    var inp = e.target;
    if (!inp || !inp.matches || !inp.matches('input[data-variant-input]')) return;
    if (inp.__vvAuto) { inp.__vvAuto = false; return; }
    var root = wurzel(inp);
    if (!root) return;
    var varianten;
    try { varianten = JSON.parse(root.querySelector('[data-variant-json]').value); } catch (err) { return; }
    var pos = parseInt((inp.getAttribute('data-index') || '').replace('option', ''), 10) - 1;
    if (isNaN(pos)) return;
    setTimeout(function () {
      var wahl = gewaehlt(root);
      var passt = varianten.some(function (v) {
        return v.options.every(function (o, i) { return wahl[i] === undefined || wahl[i] === o; });
      });
      if (passt) return;
      var beste = null, punkte = -1;
      varianten.forEach(function (v) {
        if (v.options[pos] !== inp.value) return;
        var p = 0;
        v.options.forEach(function (o, i) { if (i !== pos && wahl[i] === o) p += 2; });
        if (v.available) p += 1;
        if (p > punkte) { punkte = p; beste = v; }
      });
      if (!beste) return;
      beste.options.forEach(function (o, i) {
        if (i === pos || wahl[i] === o) return;
        var fs = root.querySelector('fieldset.variant-input-wrap[data-index="option' + (i + 1) + '"]');
        if (!fs) return;
        var ziel = Array.prototype.filter.call(fs.querySelectorAll('input[data-variant-input]'), function (x) { return x.value === o; })[0];
        if (!ziel) return;
        ziel.checked = true;
        ziel.__vvAuto = true;
        ziel.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }, 0);
  }, true);
})();
